import React, { PureComponent } from "react";

import Loader from "./../Loader/Loader.js";
import { Metric, MiniMetric, Error } from "./../Utils/Utils.js";
import Heading from "./../Elements/Heading";
import Uri from "jsuri";

class Views extends PureComponent {
  render() {
    const { loading, data, url } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    const dateRangeParameter = new Uri(url).getQueryParamValue("t");
    const dateRange =
      dateRangeParameter === "yesterday" ? "Yesterday" : "Today";

    if (loading) {
      return <Loader minHeight={400} col={"col-12 col-md-6"} />;
    }

    return (
      <div className="row mt-2">
        <div className="col-auto mb-3 mb-sm-0">
          <Heading size={6} className={"mb-1"}>
            Video Views {dateRange}
          </Heading>
          <div className="d-flex">
            <Metric
              {...data.views.total}
              size={"lg"}
              graph={data.views.total.chart}
            />
            {data.views.us.value !== null && data.views.ca.value !== null && (
              <div className="d-flex flex-column ml-4 align-self-center">
                <MiniMetric {...data.views.us} icon={"us"} />
                <MiniMetric {...data.views.ca} icon={"ca"} />
                {/* <MiniMetric {...data.views.unknown} icon={'unknown'} /> */}
              </div>
            )}
          </div>
        </div>

        <div className="col-auto ml-0 ml-md-5">
          <Heading size={6} className={"mb-1"}>
            Minutes Watched {dateRange}
          </Heading>
          <div className="d-flex">
            <Metric
              {...data.minutes_watched.total}
              size={"lg"}
              graph={data.minutes_watched.total.chart}
            />
            {data.minutes_watched.us.value !== null &&
              data.minutes_watched.ca.value !== null && (
                <div className="d-flex flex-column ml-4 align-self-center">
                  <MiniMetric {...data.minutes_watched.us} icon={"us"} />
                  <MiniMetric {...data.minutes_watched.ca} icon={"ca"} />
                  {/* <MiniMetric {...data.minutes_watched.unknown} icon={'unknown'} /> */}
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default Views;
